import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Authentification via cookie httpOnly (access_token / session_token) — aucun token en localStorage
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fileUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//.test(String(path))) return path;
  return `${API}/files/${path}`;
};
